/**
 * @generated SignedSource<<26b99acf01f72370a67b658fe50394fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type businessIntroQuery$variables = {
  bmanTin?: string | null | undefined;
  refundHistoryId: string;
};
export type businessIntroQuery$data = {
  readonly getSurveyBusinessInfo: {
    readonly business: ReadonlyArray<{
      readonly bsno: string | null | undefined;
      readonly ofbDt: string | null | undefined;
      readonly tnm: string | null | undefined;
    }> | null | undefined;
    readonly result: boolean;
  };
};
export type businessIntroQuery = {
  response: businessIntroQuery$data;
  variables: businessIntroQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bmanTin"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "refundHistoryId"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "bmanTin",
        "variableName": "bmanTin"
      },
      {
        "kind": "Variable",
        "name": "refundHistoryId",
        "variableName": "refundHistoryId"
      }
    ],
    "concreteType": "SurveyBusinessInfoOutput",
    "kind": "LinkedField",
    "name": "getSurveyBusinessInfo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "SurveyBusinessInfo",
        "kind": "LinkedField",
        "name": "business",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ofbDt",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bsno",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "tnm",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "businessIntroQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "businessIntroQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "6ee2d83f1b995a19e6a1a376a79f9201",
    "id": null,
    "metadata": {},
    "name": "businessIntroQuery",
    "operationKind": "query",
    "text": "query businessIntroQuery(\n  $refundHistoryId: String!\n  $bmanTin: String\n) {\n  getSurveyBusinessInfo(refundHistoryId: $refundHistoryId, bmanTin: $bmanTin) {\n    result\n    business {\n      ofbDt\n      bsno\n      tnm\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9c6411a81d3899b121df5c9c40adf246";

export default node;
